import { ConfigItem } from 'Core/interfaces'

export enum ContainerSearchFields {
	searchById = 'searchById',
	searchByName = 'searchByName',
	searchByCode = 'searchByCode'
}

export declare namespace PcContainer {
	interface Basic extends CodeEntity {}

	namespace Form {
		interface Add {
			name?: string
			code?: string
			containerTypeId: number | null
		}
	}

	namespace Request {
		interface Add {
			name: string
			code: string
			containerTypeId: number | null
		}

		interface Edit extends NameCode {
			containerType: ContainerType
		}
	}

	namespace Response {
		interface Add extends Entity {
			code: string
			containerType: ContainerType
		}

		interface Update extends Entity {
			code: string
			containerType: ContainerType
		}
	}

	interface ContainerType extends Entity {}

	namespace Search {
		interface Result {
			[ContainerSearchFields.searchById]: number[]
			[ContainerSearchFields.searchByName]: string[]
			[ContainerSearchFields.searchByCode]: string[]
		}

		interface Config {
			[ContainerSearchFields.searchById]: ConfigItem<ContainerSearchFields>
			[ContainerSearchFields.searchByName]: ConfigItem<ContainerSearchFields>
			[ContainerSearchFields.searchByCode]: ConfigItem<ContainerSearchFields>
		}
	}
}
